// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorSharedAddressUpsearchModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorSharedAddressUpsearchModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorSharedAddressUpsearchModel.discriminator = undefined;
EnterpriseCoordinatorSharedAddressUpsearchModel.additionalProperties = false;
EnterpriseCoordinatorSharedAddressUpsearchModel.attributeTypeMap = [
    {
        "name": "addressId",
        "baseName": "addressId",
        "type": "number"
    },
    {
        "name": "addressType",
        "baseName": "addressType",
        "type": "AddressType"
    },
    {
        "name": "addressOne",
        "baseName": "addressOne",
        "type": "string"
    },
    {
        "name": "addressTwo",
        "baseName": "addressTwo",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "country",
        "baseName": "country",
        "type": "string"
    },
];
//# sourceMappingURL=enterpriseCoordinatorSharedAddressUpsearchModel.js.map